/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Update_Line_ErrorInputs */

const vi_stocktake_update_line_error = /** @type {(inputs: Stocktake_Update_Line_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được dòng`)
};

/**

* @param {Stocktake_Update_Line_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_update_line_error = /** @type {((inputs?: Stocktake_Update_Line_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Update_Line_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_update_line_error(inputs)
});